import React, { Fragment } from "react";
import {
  PermissionOption,
  type PermissionOptionProps,
} from "./PermissionOption";
import Styles from "./PermissionOptions.module.css";

export interface PermissionOptionsProps {
  options: PermissionOptionProps[];
}

export const PermissionOptions = ({ options }: PermissionOptionsProps) => (
  <div className={Styles.optionsContainer}>
    {options.map((option, index) => (
      <Fragment key={option.value}>
        {index !== 0 && <OptionConnector />}
        <PermissionOption {...option} />
      </Fragment>
    ))}
  </div>
);

const OptionConnector = () => (
  <svg className={Styles.optionConnector} height={5} width={10}>
    <rect height={5} width={10} />
  </svg>
);
